export default "__VITE_ASSET__DmajstCs__"